/*@ngInject*/
const UIDeleteDynamicCriteriaDirective = function ($rootScope, $document) {

    var linkFunction = function ($scope, $elm, $attr) {

        function onKeydown(event) {
            if (event.keyCode === 46) { // Delete key
                $scope.$ctrl.handleDeleteKeyEventAction();
            }
        }

        $document.on('keydown.uiDeleteDynamicCriteria', onKeydown);

        $scope.$on('$destroy', function () {
            $document.off('keydown.uiDeleteDynamicCriteria', onKeydown);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiDeleteDynamicCriteria', UIDeleteDynamicCriteriaDirective);
